import React, { useEffect, useState } from "react";
import EmptyList from "../../ShoppingList/EmptyList";
// import ProfileShoppingListCard from "./ProfileShoppingListCard";

import FavoritesProductCard from "./FavoritesProductCard";
import ProfileShoppingListCard3 from "../ProfileShoppingList/ProfileShoppingListCard3";
import FavoritesPostCard from "./FavoritesPostCard";
import { XMasonry, XBlock } from "react-xmasonry";

const Lists = ({ shoppingListData, setShoppingListData, loading }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  // Effect to handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const BackgroundOnSvg = ({ children }) => (
    <div
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "8px",
        backgroundColor: "#F1F4FF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
   function getTargetBlockWidth() {
    return window.innerWidth < 440 ? 200 : 300;
  }
  return (
  <div style={{ marginTop: isSmallScreen ? "" : "4px" }}>
    {!loading && shoppingListData ? (
      shoppingListData?.length > 0 ? (
        <XMasonry
          center={false}
          responsive={true}
          maxColumns={4}
          targetBlockWidth={300}
        >
          {shoppingListData?.map((list, index) => {
            return (
              <XBlock key={index} width={1}>
                {list.type === "product" ? (
                  <FavoritesProductCard product={list.products} list={list} BackgroundOnSvg={BackgroundOnSvg}/>
                ) : list.type === "postedShoppingList" ? (
                  <FavoritesPostCard
                    list={list}
                    index={index}
                    shoppingListData={shoppingListData}
                    setShoppingListData={setShoppingListData}
                    BackgroundOnSvg={BackgroundOnSvg}
                    componentName={"Favorites"}
                  />
                ) : (
                  <ProfileShoppingListCard3
                    list={list}
                    shoppingListData={shoppingListData}
                    componentName={"Favorites"}
                  />
                )}
              </XBlock>
            );
          })}
        </XMasonry>
      ) : (
        <div style={{ height: "25rem", maxHeight: "25rem" }}>
          <div
            className={`h-100 d-flex justify-content-center align-items-center flex-column px-5`}
            style={{
              minHeight: "10vh",
              height: "25rem",
              maxHeight: "25rem",
              width: "100%",
              gap: "24px",
            }}
          >
            <svg
              style={{ width: "110px", height: "110px" }}
              width="141"
              height="141"
              viewBox="0 0 141 141"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="2"
                width="137"
                height="137"
                rx="68.5"
                stroke="#676A79"
                stroke-width="3"
              />
              <path
                d="M68.0252 39.6737C68.9677 37.5796 69.4391 36.5325 70.0954 36.2101C70.6654 35.93 71.3347 35.93 71.9047 36.2101C72.5609 36.5325 73.0324 37.5796 73.9749 39.6737L81.4822 56.3534C81.7611 56.9725 81.9003 57.282 82.1161 57.519C82.3066 57.7288 82.5399 57.8966 82.8001 58.0114C83.0944 58.1412 83.4348 58.1768 84.1155 58.2479L102.453 60.1647C104.756 60.4053 105.907 60.5256 106.419 61.0441C106.864 61.4944 107.071 62.125 106.978 62.7485C106.872 63.4662 106.012 64.2335 104.292 65.7684L90.5936 77.994C90.0855 78.4476 89.831 78.6746 89.6702 78.9508C89.5277 79.1955 89.4386 79.4668 89.4089 79.7475C89.3751 80.0648 89.4459 80.3962 89.588 81.0594L93.4141 98.9236C93.8945 101.167 94.1347 102.288 93.7952 102.931C93.5 103.489 92.9586 103.879 92.3312 103.984C91.6089 104.105 90.6062 103.533 88.6007 102.387L72.6273 93.2628C72.0345 92.9242 71.7382 92.7552 71.423 92.6887C71.1442 92.6302 70.8559 92.6302 70.577 92.6887C70.2619 92.7552 69.9655 92.9242 69.3728 93.2628L53.3994 102.387C51.394 103.533 50.3913 104.105 49.6691 103.984C49.0416 103.879 48.5 103.489 48.2051 102.931C47.8656 102.288 48.1058 101.167 48.5861 98.9236L52.4121 81.0594C52.5541 80.3962 52.6251 80.0648 52.5914 79.7475C52.5615 79.4668 52.4725 79.1955 52.33 78.9508C52.169 78.6746 51.9148 78.4476 51.4064 77.994L37.7083 65.7684C35.9886 64.2335 35.1287 63.4662 35.0218 62.7485C34.929 62.125 35.1358 61.4944 35.581 61.0441C36.0935 60.5256 37.2446 60.4053 39.5469 60.1647L57.8848 58.2479C58.5654 58.1768 58.9057 58.1412 59.2 58.0114C59.4603 57.8966 59.6935 57.7288 59.8842 57.519C60.0998 57.282 60.2391 56.9725 60.5178 56.3534L68.0252 39.6737Z"
                stroke="#676A79"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div
              style={{
                whiteSpace: "normal",
                width: "100%",
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "24px",
                color: "#676A79",
                textAlign: "center",
              }}
            >
              No Favourites Yet
            </div>
          </div>
        </div>
      )
    ) : null}
  </div>
);
};

export default Lists;
